import api from '@/configurations/service';
import PersonMixin from '@/modules/Application/mixins/PersonMixin';
import * as types from './mutation-types';

export const setSupplierCollection = async (context, search = '') => {
  const body = { active: true, isSupplier: true, maxResults: 10, search };
  const { data } = await api().post('person.get-person', body);
  const dataFormatted = PersonMixin.methods.formatPersonCollection(data);
  context.commit(types.SET_SUPPLIER_COLLECTION, dataFormatted);
};

export const setClientCollection = async (context, search = '') => {
  const body = { active: true, maxResults: 10, search };
  const { data } = await api().post('person.get-person', body);
  const dataFormatted = PersonMixin.methods.formatPersonCollection(data);
  context.commit(types.SET_CLIENT_COLLECTION, dataFormatted);
};

export const setVehicleCollection = async (context, shippingCompanyCollection) => {
  if (
    shippingCompanyCollection.fiscal &&
    Array.isArray(shippingCompanyCollection.fiscal.veiculos) &&
    shippingCompanyCollection.fiscal.veiculos.length
  ) {
    const { veiculos } = shippingCompanyCollection.fiscal;
    context.commit(types.SET_VEHICLE_COLLECTION, veiculos);
  } else {
    context.commit(types.SET_VEHICLE_COLLECTION);
  }
};

export const setShippingCompanyCollection = async (context, search = '') => {
  const body = { active: true, isDelivery: true, maxResults: 10, search };
  const { data } = await api().post('person.get-person', body);
  const dataFormatted = PersonMixin.methods.formatPersonCollection(data);
  context.commit(types.SET_SHIPPING_COMPANY_COLLECTION, dataFormatted);
};

export const setAddressCollection = async (context, person) => {
  const { addressCollection } = person;
  if (Array.isArray(addressCollection) && addressCollection.length) {
    context.commit(types.SET_ADDRESS_COLLECTION, addressCollection);
  } else {
    context.commit(types.SET_ADDRESS_COLLECTION);
  }
};

export const setUfCollection = async (context) => {
  const { data } = await api().post('person.get-uf');

  context.commit(types.SET_UF_COLLECTION, data);
};

export const changeProductParametrization = (_, payload) => {
  api().post('person.change-product-parametrization', payload);
};

export const checkIfProductIsParametrized = async (_, payload) => {
  const { data } = await api().post('person.check-if-product-is-parametrized', payload);

  return data;
};

export const registerProducts = async (_, payload) => {
  const { data } = await api().post('consumers.register-products', payload);
  return data;
};

export const checkIfCodeHasParametrization = async (_, payload) => {
  const { data } = await api().post('person.check-if-code-has-parametrization', payload);

  return data;
};

export const parametrizeAllProducts = async (_, payload) => {
  const { data } = await api().post('person.parametrize-products', payload);

  return data;
};

export const unparametrizeAllProducts = (_, payload) => {
  api().post('person.unparametrize-all-products', payload);
};

export const parameterizeTaxes = (_, payload) => {
  api().post('consumers.parameterize-taxes', payload);
};
